module.exports = __webpack_public_path__ + "img/self-introduce_male_picture_guide.81327f0f.png";